import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_crosses",
  "use": "icon_crosses-usage",
  "viewBox": "0 0 115 107",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 115 107\" id=\"icon_crosses\"><path d=\"M78 82.37h13.403V95h10.324V82.37H115v-9.74h-13.273V60H91.403v12.63H78v9.74z\" fill=\"#41C69B\" /><path d=\"M0 98.393h8.565v8.127h6.598v-8.127h8.482v-6.268h-8.482V84H8.565v8.126H0v6.268z\" fill=\"#EDF0F5\" /><path d=\"M34.065 23.481h13.973v13.26h10.764v-13.26h13.84v-10.22h-13.84V0H48.038v13.26H34.065v10.221z\" fill=\"#ED2074\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol